import { Box } from "@mui/material";

/*
 * 대시보드 공용 카드 컨테이너.
 * 흰 배경(background.paper) + 옅은 보더(divider) + 라운드 + 미세 그림자,
 * 세로 flex 레이아웃. sx 로 개별 카드에서 flex/높이 등 오버라이드.
 *
 * DW 대시보드(Sales Status 외 향후 10종)에서 카드 룩앤필 통일용.
 */
/*
 * 드릴스루 가능한 카드의 hover 룩 — 파란 보더 + 옅은 그림자 + 제목 파란색.
 *   카드 전체가 클릭 영역이면 `"&:hover": CARD_HOVER_SX`,
 *   차트 카드처럼 제목만 클릭 영역이면 제목 hover 상태를 받아 카드에 펼쳐 준다(SalesTrendChart 참고).
 *   ★ KPI 카드와 차트 카드가 같은 하이라이트를 갖도록 이 상수를 공유한다.
 *   제목 색까지 같이 도는 건 카드 제목에 CARD_TITLE_CLASS 가 붙어 있기 때문 —
 *   자체 제목을 그리는 카드는 그 클래스를 꼭 달아야 한다(DashboardCardHeader/KpiCard 는 이미 붙임).
 */
export const CARD_TITLE_CLASS = "dash-card-title";
export const CARD_HOVER_SX = {
  boxShadow: "0 2px 8px rgba(0,0,0,0.10)",
  borderColor: "primary.main",
  [`.${CARD_TITLE_CLASS}`]: { color: "primary.main" },
};
export const CARD_HOVER_TRANSITION = "box-shadow 0.15s, border-color 0.15s";

const DashboardCard = ({ children, sx = {}, ...rest }) => (
  <Box sx={{
    bgcolor: "background.paper",
    border: 1, borderColor: "divider", borderRadius: 1.5,
    p: 1.5, boxShadow: "0 1px 2px rgba(0,0,0,0.03)",
    display: "flex", flexDirection: "column",
    ...sx,
  }} {...rest}>
    {children}
  </Box>
);

export default DashboardCard;
